/* eslint-disable no-console */
import { useGlobal } from '@rcg/ui-react';
import { useQuery } from '@apollo/client';
import { LDUser } from '../utils/ldUser';
import { LAUNCH_DARKLY_FLAGS_AIR } from '../operations/queries';
import { APPLICATION_NAME } from '../utils/constants';
import getBrand from '../utils/getBrand';

const useLdFlags = () => {
  const {
    data: { lang, country },
  } = useGlobal();

  const variables = {
    ldUser: LDUser(),
    language: lang,
    clientApp: APPLICATION_NAME,
    application: APPLICATION_NAME,
    brand: getBrand().ldBrand,
    country,
  };

  const { loading, data } = useQuery(LAUNCH_DARKLY_FLAGS_AIR, {
    variables,
    fetchPolicy: 'cache-first',
  });

  const ldFlags = data?.ldFlags;

  return { loading, ldFlags };
};

export default useLdFlags;
